<template>
    <div v-if="Activity">
        <DPHeader :titlu="SentenceCase(Activity.eveniment + ' - ' + Activity.clasa)"/>
        <div class="container">
            <div class="p-3 text-end mb-3" style="background-color: #eee;">
                <router-link :to="`/activity/`+prev_activity.id" v-if="prev_activity" :title="SentenceCase(prev_activity.title)" class="btn btn-info">
                    <i class="fas fa-caret-left"></i>
                </router-link>
                <a v-else class="btn btn-secondary">
                    <i class="fas fa-caret-left"></i>
                </a>
                <span class="m-2"></span>
                <router-link :to="`/activity/`+next_activity.id" v-if="next_activity" :title="SentenceCase(next_activity.title)" class="btn btn-info">
                    <i class="fas fa-caret-right"></i>
                </router-link>
                <a v-else class="btn btn-secondary">
                    <i class="fas fa-caret-right"></i>
                </a>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <p class="mb-3">
                        Categorie: <strong>{{Activity.categorie_activitate}}</strong>
                    </p>
                    <p class="mb-3">
                        Data: <strong>{{Activity.data.getFullYear() + "." + Activity.data.getMonth() + "." + Activity.data.getDate()}}</strong>
                    </p>
                    <p class="mb-3" v-if="Activity.modul">
                        Modul: <strong>{{Activity.modul}}</strong>
                    </p>
                    <p class="mb-3">
                        Clasa: <strong>{{Activity.clasa}}</strong>
                    </p>
                    <p class="mb-3" v-if="Activity.organiser">
                        Responsabil: <strong>{{Activity.responsabil}}</strong>
                    </p>
                    <p class="mb-3" v-if="Activity.nr_participanti_clasa + Activity.nr_participanti_externi">
                        Număr de participanți:
                        <strong v-if="Activity.nr_participanti_clasa">{{Activity.nr_participanti_clasa}} elevi din clasă</strong>
                        <span v-if="Activity.nr_participanti_clasa * Activity.nr_participanti_externi">, </span>
                        <strong v-if="Activity.nr_participanti_externi">{{Activity.nr_participanti_externi}} din afara clasei</strong>
                    </p>
                    <p class="mb-3" v-if="Activity.guests">
                        Guests: <strong>{{Activity.guests}}</strong>
                    </p>


                    <div class="list-group" v-if="false">
                        <router-link :to="`/activity/`+L.id" v-for="L in cards" :key="L.id" class="list-group-item" :class="{active: L.id==activity.id}">
                            {{SentenceCase(L.title)}}
                        </router-link>
                    </div>
                </div>
                <div class="col">
                    <div class="mb-4 py-3" v-if="Activity.responsabil">
                        <h5 class="text-muted border-bottom">Responsabil</h5>
                        <div class="ps-3">
                            {{Activity.responsabil}}
                        </div>
                    </div>
                    <div class="mb-4 py-3" v-if="Activity.descriere">
                        <h5 class="text-muted border-bottom">Descriere</h5>
                        <div class="ps-3">
                            {{Activity.descriere}}
                        </div>
                    </div>

                    <div class="mb-4 py-3" v-if="Activity.details">
                        <h5 class="text-muted border-bottom">Details</h5>
                        <div class="ps-3">
                            {{Activity.details}}
                        </div>
                    </div>

                    <div class="mb-4 py-3">
                        <h5 class="text-muted border-bottom">Documente</h5>
                        <div v-if="Activity.imagini[0] || Activity.links[0]">
                            <div class="row mb-3" v-if="true">
                                <div class="col-lg-4" v-for="L in Activity.imagini" :key="L.id">
                                    <a :href="L" target="_blank" v-if="L">
                                        <img class="img-fluid border p-2" :src="`https://chl.cnlr.ro/preview/` + DriveId(L)">
                                    </a>
                                </div>
                            </div>
                            <ul v-if="Activity.links[0]">
                                <li v-for="L in Activity.links" :key="L.id">
                                    <a :href="L" target="_blank">
                                        {{L}}
                                    </a>
                                </li>
                            </ul>

                        </div>
                        <div v-else class="alert alert-warning">
                            Niciun document disponibil.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="d-flex justify-content-center align-items-center vh-100">
            <div class="text-warning" style="font-size: 6rem;">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        </div>
    </div>
</template>

<script>

import DPHeader from '@/components/DPHeader.vue'
import {Fancybox} from "@fancyapps/ui/src/Fancybox/Fancybox"
import Vuex from 'vuex'
import { useRoute } from 'vue-router'

export default {
    name: 'PageActivity',
    components: {
        DPHeader
    },
    setup() {
        
    },
    data(){
        return {
            
        }
    },
    computed:{
        title(){
            return this.Activity.eveniment + " - clasa " + this.Activity.clasa
        },
        ...Vuex.mapState(['cards', 'loading', 'activity_id']),
        ...Vuex.mapGetters(['Activity']),
        next_activity(){
            const route = useRoute()
            let E = undefined
            this.cards.forEach(element => {
                if(element.id == parseInt(route.params.id) + 1)
                {
                    E = element
                }
            });
            return E
        },
        prev_activity(){
            const route = useRoute()
            let E = undefined
            this.cards.forEach(element => {
                if(element.id == route.params.id - 1)
                {
                    E = element
                }
            });
            return E
        },
    },
    mounted(){
        const route = useRoute()
        // this.activity = this.Activity(route.params.id)
        this.$store.commit('updateActivityId', route.params.id)
        Fancybox.bind("[data-fancybox]", {});
    },
    methods:{
        TitleCase(V){
            if(! V)
                return '';
            return V.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
        },
        SentenceCase(V){
            if(! V)
                return '';
            return V.charAt(0).toUpperCase() + V.slice(1);
        },
        DrivePreview(url){
            let A = url.slice(url.indexOf('id=') + 3);
            return `https://drive.google.com/thumbnail?id=` +A;

        },
        DriveId(url){
            return url.slice(url.indexOf('id=') + 3);
        },
    }
}
</script>

<style scoped>
    
</style>
